import api from '@Services/api';
import { Import } from '@Pages/Imports/Types/Imports.types';
import {
	CRUDBase,
	DeleteSingleEntityPayload,
	GetAllMeta,
	GetSingleEntityPayload,
} from 'src/base/services/services.base';
import { AxiosResponse } from 'axios';

interface TestImportsCRUD extends CRUDBase<any, Import> {
	importAttempts: (args: FormData) => Promise<any>;
	importQuestions: (args: FormData) => Promise<any>;
}
export class TestImportsRequester implements TestImportsCRUD {
	private static instance: TestImportsRequester;
	static getInstance() {
		if (!TestImportsRequester.instance) {
			TestImportsRequester.instance = new TestImportsRequester();
		}
		return TestImportsRequester.instance;
	}
	baseURL = 'import/test';
	importAttempts = (args: FormData) => {
		return api.post(`${this.baseURL}/attempts`, args);
	};
	importQuestions = (args: FormData) => {
		return api.post(`${this.baseURL}/questions`, args);
	};
	getAll(payload?: GetAllMeta): Promise<AxiosResponse<ApiResponse<Import[]>>>;
	getAll(payload: number): Promise<AxiosResponse<ApiResponse<Import[]>>>;
	async getAll(
		payload?: any
	): Promise<import('axios').AxiosResponse<ApiResponse<Import[]>>> {
		return await api.post(`${this.baseURL}/all`, payload);
	}
	get(id: string): Promise<AxiosResponse<ApiResponse<Import>>>;
	get(id: number): Promise<AxiosResponse<ApiResponse<Import>>>;
	get(
		id: string | number,
		payload: GetSingleEntityPayload
	): Promise<AxiosResponse<ApiResponse<Import>>>;
	async get(
		id: any,
		payload?: any
	): Promise<import('axios').AxiosResponse<ApiResponse<Import>>> {
		return await api.post(`${this.baseURL}`, { id });
	}
	create(
		payload: Omit<any, 'id'>
	): Promise<AxiosResponse<ApiResponse<Import>>> {
		throw new Error('Method not implemented.');
	}
	update(payload: any): Promise<AxiosResponse<ApiResponse<Import>>> {
		throw new Error('Method not implemented.');
	}
	delete(id: number): Promise<AxiosResponse<ApiResponse<any>>>;
	delete(id: string): Promise<AxiosResponse<ApiResponse<any>>>;
	delete(
		id: string | number,
		payload: DeleteSingleEntityPayload
	): Promise<AxiosResponse<ApiResponse<any>>>;
	delete(
		id: any,
		payload?: any
	): Promise<import('axios').AxiosResponse<ApiResponse<any>>> {
		throw new Error('Method not implemented.');
	}
}
